<template>
  <section class="page-wrapper">
    <page-header v-if="title" :title="title" class="page-header"></page-header>
    <slot name="header"></slot>
    <main :class="pageContentClass">
      <slot></slot>
    </main>
  </section>
</template>

<script>
import PageHeader from "./PageHeader";

export default {
  components: {
    PageHeader
  },
  props: {
     title: {
      type: String,
      default: ""
    },
    hasPad: {
      type: Boolean,
      default: false
    },
    noPadBtm: {
      type: Boolean,
      default: false
    },
    noPadTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageContentClass() {
      return {
        "page-content": true,
        "has-pad": this.hasPad,
        "no-pad-btm": this.noPadBtm ? this.noPadBtm : false,
        "no-pad-top": this.noPadTop ? this.noPadTop : false
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-flow: column nowrap;

  flex-grow: 1;
  max-width: 100%;
  // let the column shrink so a horizontally-scrollable child contains itself
  // instead of stretching the page content wider than the viewport
  min-width: 0;

  display: flex;
  flex-flow: column nowrap;
}

.page-header {
  flex-shrink: 0;
}

.page-content {
  overflow-y: auto;
  flex-grow: 1;
  padding-bottom: 60px;

  background-color: white;
  &.has-pad {
    padding: 30px;
  }

  &.no-pad-top {
    padding-top: 0px;
  }

  &.no-pad-btm {
    padding-bottom: 0px;
  }

  &.has-bg {
    background-color: white;
  }
}
</style>
